//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

export const getIsSocialDashboardsEnabled = createHasFeatureSelector(
  FeatureNames.SocialDashboards,
);
